/* EMMERI 22-10: producten laden bij scrollen i.p.v. pagina 1, 2, 3. Werkt ook na filteren (thema tekent de sectie opnieuw). */
(function(){
  if (window.__emScroll) return; window.__emScroll = true;
  var bezig = false;
  function deel(){
    var pag = document.querySelector('.grid__item--content .pagination');
    if (!pag) return null;
    var nxt = pag.querySelector('.next a');
    var grid = pag.parentNode.querySelector('.grid.grid--uniform');
    return {pag: pag, nxt: nxt, grid: grid};
  }
  function laad(){
    var d = deel(); if (!d || bezig) return;
    d.pag.classList.add('em-scroll-pag');
    if (!d.nxt || !d.grid) { d.pag.classList.add('em-scroll-klaar'); return; }
    var r = d.pag.getBoundingClientRect();
    if (r.top > window.innerHeight + 900) return;
    bezig = true; d.pag.classList.add('em-scroll-laadt');
    fetch(d.nxt.href, {credentials: 'same-origin'}).then(function(x){ return x.text(); }).then(function(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var np = doc.querySelector('.grid__item--content .pagination');
      var ng = np ? np.parentNode.querySelector('.grid.grid--uniform') : doc.querySelector('.grid__item--content .grid.grid--uniform');
      if (ng) Array.prototype.forEach.call(ng.children, function(c){ d.grid.appendChild(document.importNode(c, true)); });
      if (np) { d.pag.replaceWith(document.importNode(np, true)); } else { d.pag.remove(); }
      document.dispatchEvent(new CustomEvent('emmeri:producten-geladen'));
      bezig = false; setTimeout(laad, 50);
    }).catch(function(){ bezig = false; d.pag.classList.remove('em-scroll-laadt', 'em-scroll-pag'); });
  }
  var t = null;
  window.addEventListener('scroll', function(){ if (t) return; t = setTimeout(function(){ t = null; laad(); }, 150); }, {passive: true});
  setInterval(laad, 1000);   /* na filteren tekent het thema de sectie opnieuw */
  laad();
})();
